/** Formata intervalo de datas ISO (yyyy-mm-dd) para exibição curta pt-PT. */
export function formatCyclePeriodLabel(startISO, endISO) {
  if (!startISO || !endISO) return '';
  const fmt = (iso) => {
    const [y, m, d] = iso.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString('pt-PT', {
      day: '2-digit',
      month: '2-digit',
    });
  };
  return `${fmt(startISO)} – ${fmt(endISO)}`;
}
